import { CURRENT_LANGUAGE } from 'consts'
import { TTS_SPEECH_API_PATH } from 'consts/api'
import ApiFactory from 'services/api-factory'
import {
  IGenerateTrialTtsRequestBody,
  IGenerateTrialTtsResponse,
  IGenerateTtsItemsRequestBody,
  ITtsItemData,
  ITtsLanguageOption,
  ITtsSpeaker,
  ITtsSpeakerTone
} from 'types/text-to-speech'
import { getQueryParams, getQueryStringForArrays } from 'utils'

const TtsApi = new ApiFactory({ baseUrl: TTS_SPEECH_API_PATH })

export const getTtsLanguageOptions_API = (model?: string) => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE,
    model
  })
  return TtsApi.get<ITtsLanguageOption[]>(`/options?${queryParams}`)
}

export const getTtsSpeakers_API = ({
  langCode,
  model
}: {
  langCode?: string
  model?: string
}) => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE,
    langCode,
    model
  })

  return TtsApi.get<ITtsSpeaker[]>(`/voices?${queryParams}`)
}

export const getTtsSpeakerTones_API = () => {
  const queryParams = getQueryParams({
    language: CURRENT_LANGUAGE
  })

  return TtsApi.get<ITtsSpeakerTone[]>(`/tones?${queryParams}`)
}

export const getTtsItems_API = (ids: number[]) => {
  const queryString = getQueryStringForArrays('ids', ids.map(String))
  return TtsApi.get<ITtsItemData[]>(`/?${queryString}`)
}

export const generateTtsItems_API = (
  requestBody: IGenerateTtsItemsRequestBody
) => {
  return TtsApi.post<ITtsItemData, IGenerateTtsItemsRequestBody>(
    '/generate',
    requestBody
  )
}

// Single-shot voice preview for the AI Avatar speech section. Returns a tts_hash;
// the generated audio arrives later over the socket keyed by that hash.
export const generateTrialTts_API = (
  requestBody: IGenerateTrialTtsRequestBody
) => {
  return TtsApi.post<IGenerateTrialTtsResponse, IGenerateTrialTtsRequestBody>(
    '/trial',
    requestBody
  )
}

export const regenerateTtsItem_API = (
  id: number,
  requestBody: IGenerateTtsItemsRequestBody
) => {
  return TtsApi.put<ITtsItemData, IGenerateTtsItemsRequestBody>(
    `/${id}`,
    requestBody
  )
}
